/*
 * @Description: 
 * @Author: xiong.zhou@dmall.com
 * @Date: 2022-03-18 10:29:17
 * @LastEditors: xiong.zhou@dmall.com
 * @LastEditTime: 2025-06-09 22:30:14
 */
import { login, getUserInfo, logOut, wxLogin, wxBinding} from '@/api/login';
import { getToken, setToken, removeToken } from '@/utils/auth';
import { connect, disconnect } from "@/utils/websocket";

const user = {
    name: 'user',
    namespaced: true,
    state: {
        token: getToken(),
        userInfo: null
    },
    actions: {
        // 登录
        async Login({ commit }, params) {
            try {
                const res = await login(params);
                const { token } = res.data;
                commit('SET_STATE', { token });
                setToken(res.data.token);
                return res;
            } catch (err) {
                return err.data;
            }
        },

        // 登录后设置token
        SetToken({ commit }, params) {
            commit('SET_STATE', { token: params.token });
            setToken(params.token);
        },

        //微信扫码后回调
        async WxLogin({ commit }, params) {
            try {
                const res = await wxLogin(params);
                if(res.code === 0){
                    const { token } = res.data;
                    commit('SET_STATE', { token });
                    setToken(res.data.token);
                }
                return res;
            } catch (err) {
                return err.data;
            }
        },

        // 用户绑定平台账号
        async WxBinding({ commit }, params) {
            try {
                const res = await wxBinding(params);
                const { token } = res.data;
                commit('SET_STATE', { token });
                setToken(res.data.token);
                return res;
            } catch (err) {
                return err.data;
            }
        },

        // 获取用户信息
        async getUserInfo({ commit }) {
            try {
                const userId = localStorage.getItem('userId') || ''
                const { data } = await getUserInfo({
                    userId
                });
                commit('SET_STATE', {
                    userInfo: data
                });
                localStorage.setItem('userId', data.id)
                connect(data.id)
                typeof recordInfoCase !== "undefined" &&
                    recordInfoCase.identify({
                        email: data.email,
                        phone: data.phone,
                        uid: data.id,
                        username: data.name,
                    });
            } catch (err) {
                disconnect()
                removeToken();
                console.info('获取用户信息失败：',err);
                window.location.reload();
                throw new Error(err);
            }
        },

        // 注销
        async LogOut({ commit }) {
            try {
                await logOut();
                commit('SET_STATE', {
                    userInfo: null
                });
                disconnect()
                removeToken();
                window.location.reload();
            } catch (err) {
                throw new Error(err);
            }
        }
    }
};

export default user;
